import { useQuery } from "@apollo/client/react";



































export const useDataClientQuery = useQuery;
